/* src/app/components/payroll/timesheets/timesheet-payroll-adjustment-approvals/timesheet-payroll-adjustment-approvals.component.css */
.table-style {
  width: 100%;
}
.error-message1 {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
}
::ng-deep ppl-popup-dialog div.popup-dialog.position-dialog div.content.medium {
  width: 90vw;
  max-width: 60%;
}
::ng-deep ppl-popup-dialog form div.alert.alert-warning {
  width: 100%;
}
::ng-deep ppl-timesheet-payroll-adjustment-approvals ppl-popup-dialog div.popup-dialog.position-dialog.center {
  top: 0;
  left: 0;
  height: 100vh;
}
.approval-dialog-table {
  table-layout: fixed;
  width: 100%;
  font-size: 12px;
  border-collapse: separate;
  border-spacing: 0;
}
.approval-dialog-table th,
.approval-dialog-table td {
  border: none;
  padding: 8px 10px !important;
  vertical-align: top;
  word-break: break-word;
}
.approval-dialog-table th {
  font-weight: 600;
  line-height: 1.3;
}
.approval-dialog-table input.ant-input {
  height: 32px !important;
  min-height: 32px !important;
  box-sizing: border-box !important;
  padding: 0 11px !important;
  border-radius: 4px;
  font-size: 12px !important;
  line-height: 30px !important;
  width: 100%;
}
.error-message {
  color: red;
  font-size: 11px;
  min-height: 14px;
  line-height: 1.3;
  margin-top: 4px;
}
.save-row {
  margin-top: 16px;
  padding: 0 4px;
}
/*# sourceMappingURL=timesheet-payroll-adjustment-approvals.component-AJ5ZME2R.css.map */
